import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Paper from "@material-ui/core/Paper"

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "auto",
    maxWidth: 1080,
    paddingBottom: theme.spacing(6),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(6),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6),
    },
    "@media print": {
      "box-shadow": "none !important",
      margin: "auto",
      paddingBottom: theme.spacing(6),
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6),
      paddingTop: theme.spacing(6),
      padding: 0,
      "& body": {
        minWidth: 1200,
      },
      "& h1": {
        pageBreakBefore: "always",
      },
      "& h1, & h2, & h3, & h4, & h5": {
        pageBreakAfter: "avoid",
      },
      "& p": {
        pageBreakInside: "avoid",
      },
    },
  },
}))
//body { display: table; table-layout: fixed; padding-top: 2.5cm; padding-bottom: 2.5cm; height: auto;}
const SetOrientation = () => (
  <style type="text/css">
    {
      "@media print{@page {size: letter portrait; margin: 40pt 30pt 40pt; overflow: visible; @bottom-right {content: counter(page); display: block;} @top-right {content: 'Condominium Disclosure Statement'; margin: 30pt 0 10pt 0; font-size: 8pt;}}}"
    }
  </style>
)

const DocumentContainer = React.forwardRef(({ children, data, elevation }, ref) => {
  const classes = useStyles()

  return (
    <Paper className={classes.root} elevation={elevation != null ? elevation : 2} ref={ref}>
      <SetOrientation />
      <div>{children}</div>
    </Paper>
  )
})

export default DocumentContainer
